import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import ArrowDown from 'shared-components/icons/ArrowDown';
import { useElementDimensions } from '../../../../../../utils/hooks/use-element-dimensions';

export const AddOnsTaxesAndFees = ({ masterContract, currency }) => {
  const masterCalculations = masterContract?.calculations;
  const guestCalculations = masterCalculations?.guest;
  const hostTaxesAndFees = masterCalculations?.add_on_taxes_and_fees;
  let total = masterCalculations?.add_ons?.taxes_and_fees;
  if (guestCalculations?.us_sales_tax_add_ons > 0) {
    total += guestCalculations.us_sales_tax_add_ons;
  }

  const [setCollapseRef, contentDims] = useElementDimensions();
  const [isOpen, setIsOpen] = useState(false);
  const [collapseStyles, setCollapseStyles] = useState({
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    height: '0px'
  });

  useEffect(() => {
    setCollapseStyles((prev) => ({
      ...prev,
      height: prev.height === '0px' ? `${contentDims.height}px` : '0px'
    }));
  }, [isOpen]);

  return (
    <div data-testing-id="price-breakdown-taxes-fees">
      <div
        className="flex space-between"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="flex middle">
          <FormattedMessage
            id="inbox.taxes_and_fees_label.taxes_fees"
            defaultMessage="Taxes & Fees"
          />
          <span
            className="margin-sm-left flex middle center"
            style={{
              transition: 'all 0.2s ease',
              transform: !isOpen ? 'rotate(-90deg)' : 'none'
            }}
          >
            <ArrowDown />
          </span>
        </span>
        <span>
          <span data-testing-id="taxes-and-fees-total">
            <FormattedNumber
              value={total}
              currency={currency}
              style="currency"
            />
          </span>
        </span>
      </div>

      <div style={collapseStyles}>
        <div ref={setCollapseRef}>
          {(hostTaxesAndFees || []).map((charge) => {
            const displayString =
              charge.type === 'fee' ? charge.label : charge.label_info;

            return (
              <div className="flex space-between text-small text-gray-600 margin-sm-top">
                <div>{displayString}</div>
                <div data-testing-id="fee-amount">
                  <FormattedNumber
                    value={charge.amount}
                    currency={currency}
                    style="currency"
                  />
                </div>
              </div>
            );
          })}
          {guestCalculations?.us_sales_tax_add_ons > 0 && (
            <div className="flex space-between text-small text-gray-600 margin-sm-top">
              <div>
                <FormattedMessage
                  id="price-breakdown.add-on-sales-tax"
                  defaultMessage="Add-on sales tax"
                />
              </div>
              <div data-testing-id="add-on-sales-tax-amount">
                <FormattedNumber
                  value={guestCalculations?.us_sales_tax_add_ons}
                  currency={currency}
                  style="currency"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

AddOnsTaxesAndFees.propTypes = {
  masterContract: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired
};
